import TripsMonitoredReportContainer, {
  TripsMonitoredReportHelp,
} from './pages/tripsMonitoredReportContainer';

import MessageConfigurationContainer, {
  MessageConfigurationHelp,
} from './pages/messageConfigurationContainer';

import TestMessagingContainer, {
  TestMessagingHelp,
} from './pages/testMessagingContainer';

import EditUserContainer from './pages/editUserContainer';
import ManageUsersContainer, {
  ManageUsersHelp,
} from './pages/manageUsersContainer';

import FlightSearchContainer, {
  FlightHelp,
} from './pages/flightSearchContainer';

import ViewFlightContainer from './pages/viewFlightContainer';

import CreateTripGroupContainer, {
  CreateTripGroupHelp,
} from './pages/createTripGroupContainer';
import ManageTripGroupsContainer, {
  ManageTripGroupsHelp,
} from './pages/manageTripGroupsContainer';
import EditTripGroupContainer, {
  EditTripGroupHelp,
} from './pages/editTripGroupContainer';
import HomePage from './headersegment/home';
import WaiverReport from './reports/waivers/WaiverReport';
import IssueReport from './reports/issues/IssueReport';
import TravelerProfileSearchContainer from './agent/traveler/search/TravelerProfileSearchContainer';
import TravelerProfileContainer from './agent/traveler/TravelerProfileContainer';
import AgentSettingsContainer from './user/settings/AgentSettingsContainer';
import IssueSearch from './headersegment/Issues';
import TripPage from '../views/trips/Trip';
// import AccountSettingsContainer from './account/settings/AccountSettingsContainer';
import AccountSettingsHelp from './pages/accountSettingsContainer/AccountSettingsHelp';
import AccountSettingsContainer from './pages/accountSettingsContainer/AccountSettingsContainer';
import TravelerRegisterPreviewContainer from './traveler/register/TravelerRegisterPreviewContainer';
import TravelerProfilePreviewContainer from './traveler/profile/TravelerProfilePreviewContainer';
import TravelerLoginPreviewContainer from './traveler/login/TravelerLoginPreviewContainer';
import TravelerRegisterContainer from './traveler/register/TravelerRegisterContainer';
import TravelerLoginContainer from './traveler/login/TravelerLoginContainer';
import TravelerProfileContainers from './traveler/profile/TravelerProfileContainer';
import TravelerForgotContainer from './traveler/forgot/TravelerForgotContainer';
import TravelerErrorContainer from './traveler/TravelerErrorContainer';
import TravelerTermsContainer from './traveler/TravelerTerms';
import TravelerOptOutContainer from './traveler/optOut/TravelerOptOutContainer';

import Trips from '../views/trips/Trips';
import AdminComponent from './admin/AdminComponent';
import AccountsAdminComponent from './admin/AccountsAdminComponent';
import { Error403, Error404 } from '../views/template/ErrorComponents';
import TripNotificationContainer from './trips/TripNotificationContainer';
import WaiverOverview from './waivers/Overview';
import WaiverWorkItemContainer from './waivers/workItems/WaiverWorkItemContainer';
import WaiverWorkItemListContainer from './waivers/workItems/WaiverWorkItemListContainer';
import WaiverEditConfigView from './waivers/WaiverEditConfigView';
import MapComponent from './map/component/MapComponent';
import UsageReportingContainer from './pages/usageReportingContainer/UsageReportingContainer';
import { UsageReportingHelp } from './pages/usageReportingContainer/UsageReportingHelp';

// update comment below when changing paths
export const HomePath = '/home';
export const SettingsPath = '/settings';

// Trips Tab Paths
export const TripSearch = '/trips/search';
export const TripPath = '/trip/:tripId';
export const TripNotificationPath =
  '/trips/:tripId/notifications/:notificationId';
export const TripsMonitoredReportPath = '/trips/reporting';
export const FlightSearchPath = '/flights/search';
export const ViewFlightPath = '/flights/:flightId'; // (optional?) query params flightNumber && carrier

// Issues Tab Paths
export const IssuesOpenPath = '/issues/open';
export const IssuesSearchPath = '/issues/search';
export const IssuesMyPath = '/issues/my';
export const IssueReportingPath = '/issues/reporting';

//Waivers Tab Paths
export const WaiverPath = '/waivers';
export const WaiverConfigPath = '/waivers/configurations';
export const WaiverEditPath = '/waivers/:waiverId/edit';
export const WaiverWorkItemPath = '/waivers/workItem/:workItemId';
export const WaiverWorkItemListPath = '/waivers/workItems/list';
export const WaiverVersionPath = '/waivers/:waiverId/version/:waiverVersion';
export const WaiverReportingPath = '/waivers/reporting';
export const WaiverIDPath = '/waivers/:waiverId';

//Traveler Search Tab Paths
export const TravelerProfileSearchPath = '/agent/traveler/profile/search';
export const TravelerProfilePath =
  '/agent/traveler/profile/searchresult/:travelerKey';

//Account Settings Tab Paths
export const TestMessagingPath = '/messaging/test';
export const TripAlertBrandingPath = '/account/settings';
export const MessageConfigurationPath = '/messageConfiguration';
export const MessageConfigurationWithUrlPath =
  '/messageConfiguration/:messageConfigurationId';
export const ManageUserPath = '/users';
export const CreateUserPath = '/users/create';
export const EditUserPath = '/users/:newUserId';
export const CreateTripGroupPath = '/tripGroups/create';
export const ManageTripGroupsPath = '/tripGroups';
export const EditTripGroupPath = '/tripGroups/:tripGroupId';
export const UsageReportingPath = '/account/usage-reporting';
export const TravelerRegisterPreview = '/traveler/register/preview';
export const TravelerProfilePreview = '/traveler/profile/preview';
export const TravelerLoginPreview = '/traveler/login/preview';

//Traveler Paths
export const TravelerRegister = '/traveler/register';
export const TravelerProfileLogin = '/traveler/login';
export const Traveler = '/traveler';
export const TravelerProfile = '/traveler/profile';
export const TravelerForgotLogin ='/traveler/forgot';
export const TravelerError = '/traveler/error';
export const TravelerTerms ='/traveler/terms';
export const TravelerOptOut ='/traveler/optOut';
export const TravelerLogout = '/traveler/logout';

//Admin Tab Paths
export const AdminPath = '/admin';
export const AdminAccountsPath = '/admin/accounts/:accountId';

//Error Paths
export const Error403Path = '/403';
export const Error404Path = '/404';

//Map Tab Paths
export const MapPath = '/map';

export type AppRoute = {
  Content: React.ComponentType;
  title: string;
  path: string;
  helperFlag?: boolean;
  supportFlag?: boolean;
  HelpPageComponent?: React.ComponentType;
};

const agentRoutes: AppRoute[] = [
  {
    Content: HomePage,
    title: 'Home',
    path: HomePath,
    helperFlag: true,
  },
  {
    Content: AgentSettingsContainer,
    title: 'Agent Settings',
    path: SettingsPath,
    helperFlag: true,
    supportFlag: true
  },
  //Trips Tab
  {
    Content: Trips,
    title: 'Search Trips',
    path: TripSearch,
    helperFlag: true,
  },
  {
    Content: TripPage,
    title: 'Trip Details',
    path: TripPath,
    helperFlag: true,
  },
  {
    Content: TripNotificationContainer,
    title: 'Trip Details',
    path: TripNotificationPath,
    helperFlag: true,
  },
  {
    Content: TripsMonitoredReportContainer,
    title: 'Trips Monitored Report',
    path: TripsMonitoredReportPath,
    HelpPageComponent: TripsMonitoredReportHelp,
  },
  {
    Content: FlightSearchContainer,
    title: 'Flight Search',
    path: FlightSearchPath,
    HelpPageComponent: FlightHelp,
  },
  {
    Content: ViewFlightContainer,
    title: 'View Flight',
    path: ViewFlightPath,
    HelpPageComponent: FlightHelp,
  },

  //Issues Tab
  {
    Content: IssueSearch,
    title: 'Issue Search',
    path: IssuesOpenPath,
    helperFlag: true,
  },
  {
    Content: IssueSearch,
    title: 'Issue Search',
    path: IssuesSearchPath,
    helperFlag: true,
  },
  {
    Content: IssueSearch,
    title: 'Issue Search',
    path: IssuesMyPath,
    helperFlag: true,
  },
  {
    Content: IssueReport,
    title: 'Issue Reporting',
    path: IssueReportingPath,
    helperFlag: true,
  },

  //Waivers Tab
  {
		Content: WaiverOverview,
    title: 'Waivers',
		path: WaiverPath,
		helperFlag: true
	},
  {
		Content: WaiverEditConfigView,
    title: 'Waiver Editor',
		path: WaiverConfigPath,
		helperFlag: true
	},
  {
		Content: WaiverEditConfigView,
    title: 'Waiver Editor',
		path: WaiverEditPath,
		helperFlag: true
	},
  {
		Content: WaiverEditConfigView,
    title: 'Waiver Editor',
		path: WaiverVersionPath,
		helperFlag: true
	},
  {
		Content: WaiverWorkItemContainer,
    title: 'Waiver Work Items',
		path: WaiverWorkItemPath,
		helperFlag: true,
	},
  {
		Content: WaiverWorkItemListContainer,
    title: 'Waiver Work Items',
		path: WaiverWorkItemListPath,
		helperFlag: true,
	},
  {
    Content: WaiverReport,
    title: 'WAIVER REPORTING',
    path: WaiverReportingPath,
    helperFlag: true,
  },
  {
		Content: WaiverEditConfigView,
    title: 'Waivers',
		path: WaiverIDPath,
		helperFlag: true
	},

  //Traveler Search Tab
  {
    Content: TravelerProfileSearchContainer,
    title: 'Traveler Profile',
    path: TravelerProfileSearchPath,
    helperFlag: true
  },
  {
    Content: TravelerProfileContainer,
    title: 'Traveler Profile',
    path: TravelerProfilePath,
    supportFlag: true
  },

  //Account Settings Tab
  {
    Content: TestMessagingContainer,
    title: 'Test Messaging',
    path: TestMessagingPath,
    HelpPageComponent: TestMessagingHelp,
  },
  {
    Content: AccountSettingsContainer,
    title: 'TRIP ALERT BRANDING',
    path: TripAlertBrandingPath,
    HelpPageComponent: AccountSettingsHelp,
  },
  {
    Content: MessageConfigurationContainer,
    title: 'Email Configuration',
    path: MessageConfigurationPath,
    HelpPageComponent: MessageConfigurationHelp,
  },
  {
    Content: MessageConfigurationContainer,
    title: 'Email Configuration',
    path: MessageConfigurationWithUrlPath,
    HelpPageComponent: MessageConfigurationHelp,
  },
  {
    Content: ManageUsersContainer,
    title: 'Manage Users',
    path: ManageUserPath,
    HelpPageComponent: ManageUsersHelp,
  },
  {
    Content: EditUserContainer,
    title: 'Create User',
    path: CreateUserPath,
    HelpPageComponent: ManageUsersHelp,
  },
  {
    Content: EditUserContainer,
    title: 'Edit User',
    path: EditUserPath,
    HelpPageComponent: ManageUsersHelp,
  },
  {
    Content: CreateTripGroupContainer,
    title: 'Create Trip Group',
    path: CreateTripGroupPath,
    HelpPageComponent: CreateTripGroupHelp,
  },
  {
    Content: ManageTripGroupsContainer,
    title: 'Manage Trip Groups',
    path: ManageTripGroupsPath,
    HelpPageComponent: ManageTripGroupsHelp,
  },
  {
    Content: EditTripGroupContainer,
    title: 'Edit Trip Group',
    path: EditTripGroupPath,
    HelpPageComponent: EditTripGroupHelp,
  },
  {
    Content: UsageReportingContainer,
    title: 'Usage Reporting',
    path: UsageReportingPath,
    HelpPageComponent: UsageReportingHelp,
  },

  //Admin Tab
  {
    Content: AdminComponent,
    title: 'Admin',
    path: AdminPath,
    helperFlag: true,
  },
  {
    Content: AccountsAdminComponent,
    title: 'Admin Accounts',
    path: AdminAccountsPath,
    helperFlag: true,
  },

  //Error Pages
  {
    Content: Error403,
    title: 'Forbidden',
    path: Error403Path,
  },
  {
    Content: Error404,
    title: 'Not Found',
    path: Error404Path,
  },
];

const travelerRoutes: AppRoute[] = [
  {
    Content: TravelerRegisterPreviewContainer,
    title: 'Traveler Register Preview',
    path: TravelerRegisterPreview,
    helperFlag: true,
  },
  {
    Content: TravelerProfilePreviewContainer,
    title: 'Traveler Profile Preview',
    path: TravelerProfilePreview,
    helperFlag: true,
  },
  {
    Content: TravelerLoginPreviewContainer,
    title: 'Traveler Login Preview',
    path: TravelerLoginPreview,
    helperFlag: true,
  },
  {
    Content: TravelerRegisterContainer,
    title: 'Traveler Register',
    path: TravelerRegister,
    helperFlag: true,
  },
  {
    Content: TravelerLoginContainer,
    title: 'Traveler Login',
    path: TravelerProfileLogin,
    helperFlag: true,
  },
  {
    Content: TravelerProfileContainers,
    title: 'Traveler Profile',
    path: Traveler,
    helperFlag: true,
  },
  {
    Content: TravelerProfileContainers,
    title: 'Traveler Profile',
    path: TravelerProfile,
    helperFlag: true,
  },
  {
    Content: TravelerForgotContainer,
    title: 'Traveler Forgot Login',
    path: TravelerForgotLogin,
    helperFlag: true,
  },
  {
    Content: TravelerErrorContainer,
    title: 'Traveler Error',
    path: TravelerError,
    helperFlag: true,
  },
  {
    Content: TravelerTermsContainer,
    title: 'Traveler Terms',
    path: TravelerTerms,
    helperFlag: true,
  },
  {
    Content: TravelerOptOutContainer,
    title: 'Traveler OptOut',
    path: TravelerOptOut,
    helperFlag: true,
  },
];

const mapRoutes: AppRoute[] = [
  {
    Content: MapComponent,
    title: 'Map',
    path: MapPath,
    helperFlag: true,
  },
]

const appRoutes: AppRoute[] = [...agentRoutes, ...travelerRoutes, ...mapRoutes];
export default appRoutes;
